var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.137,
    height: 86.322,
    viewBox: "0 0 84.137 86.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7536",
    x: -0.001,
    y: 0,
    width: 72.522,
    height: 64.102,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.243
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7537",
    x: 52.186,
    y: 47.477,
    width: 31.565,
    height: 21.624,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940",
    transform: "translate(6931.137 -4000.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3921",
    "data-name": "Group 3921",
    transform: "translate(487.635 -76.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914",
    transform: "translate(-7410.773 4085.298)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, -7.98)",
    filter: "url(#Path_7536)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7536-2",
    "data-name": "Path 7536",
    d: "M2068.52-35.755c-.363-1.1-.229-1.745.393-2.287a1.424,1.424,0,0,0,.29-.752,23.586,23.586,0,0,0,.755-7.336,21.968,21.968,0,0,1,1.052-9.488,18.125,18.125,0,0,0,1.035-9.1c-.181-1.023-.332-1.876-1.343-2.379-.3-.151-.875-.412-.528-.868,1.187-1.56.277-2.989-.206-4.433a1.8,1.8,0,0,1,.112-1.662,5.936,5.936,0,0,0,.7-2.812,18.158,18.158,0,0,0-.588-4.651c-.163-.834.658-1.976-.274-2.414-.718-.338-1.765.067-2.665.06-1.329-.01-2.631.6-3.965.209a11.078,11.078,0,0,0-4.554-.081c-2.657.334-4.373,2.213-6.105,3.955-2.01,2.022-3.709,4.375-6.416,5.594a1.168,1.168,0,0,0-.6,1.3c.042.543.484.77.945.934,1.244.444,1.432.994.6,2.125a1.535,1.535,0,0,0-.2,1.727c.661,1.5-.079,2.977-1.643,2.883a2.894,2.894,0,0,0-2.677,1.479,3.313,3.313,0,0,1-3.455,1.475,6.387,6.387,0,0,0-4.014.479,1.5,1.5,0,0,1-1.745-.327,3.985,3.985,0,0,0-2.2-.967c-2.75-.708-5.466-.168-8.183.169-.518.064-1.416.1-1.378.795.049.868-.225,1.917.684,2.59.563.417,1.252,2.865.786,3.17a35.872,35.872,0,0,0-3.06,2.848,24.917,24.917,0,0,1-3.056,1.932,2.555,2.555,0,0,0-1.293,2.382c-.046.748.187,1.069.944,1.067,1.017,0,2.036.085,3.053.072,11.342-.135,22.69.074,34.026-.437a1.607,1.607,0,0,1,1.813,1.048,1.193,1.193,0,0,0,1.18.814c1.212-.038,1.559.606,1.427,1.7a7.958,7.958,0,0,0,.046.935c0,1.335.366,2.4,1.882,2.677a1.2,1.2,0,0,1,.673.445,10.857,10.857,0,0,0,2.814,2.083C2065.145-37.863,2067.087-37.591,2068.52-35.755Z",
    transform: "translate(-2007.72 92.05)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, -7.98)",
    filter: "url(#Path_7537)",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7537-2",
    "data-name": "Path 7537",
    d: "M2478.1,324.221c-1.809,1.547-4.109,1.852-6.284,2.473-.339.1-.708.258-1.031.072-1.534-.878-2.787-.372-3.959.72a2.694,2.694,0,0,1-1.771.485c-.837.069-.408.789-.556,1.2-.17.468.23.511.554.471,2.821-.346,5.729-.222,8.332-1.7,2-1.139,4.276-1.779,6.256-3.373C2479.081,324.227,2478.711,323.7,2478.1,324.221Z",
    transform: "translate(-2404.26 -268.55)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNy);
export default __webpack_public_path__ + "static/media/NY.ea8d61f86028e35d1af5c0e55e433af1.svg";
export { ForwardRef as ReactComponent };